module.exports = __webpack_public_path__ + "static/scale-model-of-clyde-wilson-memorial-park-in-columbia-missouri-c9f7f5cbe7a2512eea358d7a5a670bb6.png";